export const matchingApiPaths = <const>{
    addMatching: 'matching/qbooks/add',
    addXeroMatchedPosRequestersToActiveStep: 'matching/xero/addMatchedPosRequestersToActiveStep',
    deleteMatching: 'matching/qbooks/delete',
    getMatchingInfoV2: 'matching/qbooks/getInfoV2',
    getQBooksMatchingContext: 'matching/qbooks/getContext',
};
